<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1>Acknowledgments</h1>
<p style="text-align: center;">Pat Coleman, Brian Bahlmann, Lloyd Bahlmann, and Brian<br/>
Whitecliffe-Davies</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?22e2b4f4